import { render, staticRenderFns } from "./OrganizationDeletedRow.vue?vue&type=template&id=77bee300"
import script from "./OrganizationDeletedRow.vue?vue&type=script&lang=js"
export * from "./OrganizationDeletedRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports